export const CREATE_TICKET = "CREATE_TICKET";
export const SEARCH_USER = "SEARCH_USER";